"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _config = _interopRequireDefault(require("../config"));
var _default = exports.default = function _default(baseUrl) {
  if (_config.default.nui.signinapp) {
    return baseUrl;
  }
  if (process.env.NODE_ENV === 'production') {
    return "".concat(_config.default.nui.signin.domain, "/nui/signin");
  }
  return "".concat(baseUrl, "/signin");
};